import { useTranslations } from 'next-intl';
import { Loading } from '@/app/components/icons/Loading';

interface LoadingOverlayProps {
  loadingText?: string;
}

export const LoadingOverlay = ({ loadingText }: LoadingOverlayProps) => {
  const t = useTranslations();
  return (
    <div className="flex h-16 w-16 flex-col items-center justify-center gap-2 rounded-8 bg-system-black36">
      <Loading className="animate-spin text-2xl" />
      <div className="text-system-white48 text-xs">{loadingText || t('create.createForm.upload.uploading')}</div>
    </div>
  );
};
